<template>
  <div
    v-if="visible"
    id="mask"
    class="mask-show login-rules-notify-root"
    role="dialog"
    aria-modal="true"
    aria-labelledby="login-rules-title"
    @click.self="onAgree"
  >
    <div class="login-notify">
      <div class="close mask-close" @click.stop="onAgree" />
      <div class="mask-item">
        <div class="login-notify-contain">
          <h3 id="login-rules-title">PERATURAN PERMAINAN</h3>
          <div class="login-rule-content">
            <div class="wdbos-rules-container">
              <p class="wdbos-intro-text">
                Selamat datang! Dengan mendaftar dan bermain, Anda dianggap telah membaca dan menyetujui seluruh
                peraturan di bawah ini.
              </p>

              <h2 class="wdbos-heading">I. Pendaftaran dan Keamanan Akun</h2>
              <ul class="wdbos-rules-list wdbos-security-list">
                <li class="wdbos-rule-item">
                  Data yang diisi pada form pendaftaran harus <span class="wdbos-highlight">BENAR &amp; ASLI</span>.
                </li>
              </ul>

              <h2 class="wdbos-heading">II. Deposit dan Withdraw</h2>
              <ul class="wdbos-rules-list wdbos-deposit-list">
                <li class="wdbos-rule-item">
                  Deposit &amp; Withdraw hanya diproses sesuai
                  <span class="wdbos-highlight">nama dan nomor rekening yang terdaftar</span>.
                </li>
                <li class="wdbos-rule-item wdbos-rule-item-important">
                  Pengiriman dana deposit atas nama orang lain / pihak ke-3
                  <span class="wdbos-highlight">tidak dapat diproses &amp; dianggap HANGUS / DONATUR</span>.
                </li>
                <li class="wdbos-rule-item">
                  Selalu periksa <span class="wdbos-highlight">nama dan nomor rekening tujuan deposit</span> sebelum
                  transfer, dikarenakan nomor rekening deposit dapat berubah sewaktu - waktu.
                </li>
                <li class="wdbos-rule-item wdbos-rule-item-important">
                  Untuk member dengan nama rekening bank tunggal (contoh : Andi, Ujang),
                  <span class="wdbos-highlight">WAJIB deposit dengan nominal unik/acak</span>. Ketentuan yang sama juga
                  berlaku untuk transfer ke bank yang berbeda (Transfer Antar Bank Online).
                </li>
              </ul>

              <h2 class="wdbos-heading">III. Aturan Betting dan Permainan</h2>
              <ul class="wdbos-rules-list wdbos-betting-list">
                <li class="wdbos-rule-item">
                  Betting yang Normal adalah disaat pasaran betting dibuka. Semua pembelian / betting yang telah
                  dilakukan <span class="wdbos-highlight">tidak dapat dibatalkan</span>.
                </li>
              </ul>

              <h2 class="wdbos-heading">IV. Tindakan Tegas dan Mutlak</h2>
              <ul class="wdbos-rules-list wdbos-strict-list">
                <li class="wdbos-rule-item wdbos-rule-item-important">
                  Kami akan melakukan tindakan tegas terhadap yang melakukan
                  <span class="wdbos-highlight">penipuan deposit berulang-ulang</span> ataupun telah dinyatakan melakukan
                  <span class="wdbos-highlight">permainan yang tidak wajar</span>. Semua tindak penipuan atau bentuk
                  apapun yang merugikan pihak kami dan pihak-pihak lainnya akan di
                  <span class="wdbos-highlight">BANNED account anda tanpa pengecualian</span>.
                </li>
                <li class="wdbos-rule-item wdbos-rule-item-important">
                  Segala keputusan <span class="wdbos-highlight">MARIBOS.com</span> bersifat
                  <span class="wdbos-highlight">mutlak</span>.
                </li>
              </ul>

              <div class="wdbos-footer">Terima kasih – Selamat bermain dan Salam JP!</div>

              <div class="wdbos-logo-container">
                <img
                  src="@/assets/images/logo.png"
                  alt="Logo"
                  class="wdbos-logo-image"
                  @error="onLogoError"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="login-success-btn">
        <a href="javascript:;" class="jq-login-agree" @click.prevent="onAgree">Saya Setuju</a>
        <a href="javascript:;" class="jq-login-reject" @click.prevent="onReject">Saya Tidak Setuju</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { toastSuccess } from '@/utils/toast'

export default {
  name: 'LoginRulesNotify',
  computed: {
    ...mapState('user', {
      visible: state => state.loginRulesNotifyVisible
    })
  },
  methods: {
    onLogoError(e) {
      const el = e && e.target
      if (el) el.style.display = 'none'
    },
    onAgree() {
      this.$store.dispatch('user/setLoginRulesNotify', false)
    },
    async onReject() {
      this.$store.dispatch('user/setLoginRulesNotify', false)
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
#mask.login-rules-notify-root {
  position: fixed;
  inset: 0;
  z-index: 100002;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background: rgba(0, 0, 0, 0.72) !important;
}

#mask.login-rules-notify-root .login-notify {
  position: relative;
  width: 100%;
  max-width: none;
  flex: 1 1 auto;
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  max-height: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1rem 0 0;
  padding-bottom: 0;
  border-radius: 0;
  margin: 0;
  box-sizing: border-box;
  background: #1a1210 !important;
}

#mask.login-rules-notify-root .login-notify-contain > h3 {
  color: #e8c48a !important;
  background: #111 !important;
}

#mask.login-rules-notify-root .mask-item {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

#mask.login-rules-notify-root .login-notify-contain {
  padding-bottom: 0.5rem;
}

#mask.login-rules-notify-root .login-success-btn {
  position: relative !important;
  bottom: auto !important;
  left: auto !important;
  flex-shrink: 0;
  padding: 1rem 0 1.25rem;
  box-sizing: border-box;
}

.wdbos-rules-container {
  max-width: none;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  background: linear-gradient(180deg, #1a1210 0%, #242323 45%, #1a1210 100%);
  padding: 30px;
  font-family: PingFangSC-Medium, 'PingFang SC', 'Microsoft YaHei UI', verdana, tahoma;
  color: #fff;
}

.wdbos-header-main {
  font-size: 2.5em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #ffd700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.wdbos-heading {
  color: #ffd700;
  border-bottom: 2px solid #ffd700;
  padding-bottom: 10px;
  margin-top: 30px;
  font-size: 1.5em;
}

.wdbos-rules-list {
  list-style: none;
  padding-left: 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 15px;
  margin: 15px 0;
  transition: all 0.3s ease;
}

.wdbos-rules-list:hover {
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.wdbos-rules-list li {
  margin: 15px 0;
  padding-left: 25px;
  position: relative;
  line-height: 1.6;
}

.wdbos-rules-list li::before {
  content: '▶';
  color: #ffd700;
  position: absolute;
  left: 0;
}

.wdbos-highlight {
  color: #ffd700;
  font-weight: bold;
}

.wdbos-footer {
  text-align: center;
  margin-top: 40px;
  padding: 20px;
  border-top: 2px solid #ffd700;
  font-style: italic;
  color: #ffd700;
}

.wdbos-rule-item {
  transition: all 0.3s ease;
  padding: 8px 0;
}

.wdbos-rule-item:hover {
  transform: translateX(5px);
  background: rgba(255, 215, 0, 0.1);
  border-radius: 4px;
}

.wdbos-rule-item-important {
  border-left: 3px solid #f00;
  padding-left: 22px !important;
}

.wdbos-security-list,
.wdbos-deposit-list,
.wdbos-betting-list,
.wdbos-strict-list {
  border: 1px solid rgba(200, 161, 119, 0.55);
  background: rgba(0, 0, 0, 0.35);
}

.wdbos-strict-list {
  border-color: rgba(200, 161, 119, 0.75);
}

.wdbos-logo-container {
  text-align: center;
  margin-top: 30px;
  padding: 20px;
}

.wdbos-logo-image {
  max-width: 500px;
  height: auto;
  width: 100%;
}

.wdbos-intro-text {
  text-align: center;
  font-style: italic;
  margin-bottom: 30px;
  padding: 0 10px;
}

@media (min-width: 1024px) {
  .wdbos-rules-container {
    padding: 3vh;
  }

  .wdbos-header-main {
    font-size: 3.6vh;
    margin-bottom: 2vh;
  }

  .wdbos-heading {
    font-size: 2.4vh;
    margin-top: 2vh;
    padding-bottom: 1vh;
  }

  .wdbos-rules-list {
    padding: 1.5vh;
    margin: 1vh 0;
  }

  .wdbos-rules-list li {
    margin: 1.2vh 0;
    padding-left: 2vh;
    line-height: 1.4;
  }

  .wdbos-footer {
    margin-top: 2vh;
    padding: 1.5vh;
  }

  .wdbos-logo-image {
    max-height: 12vh;
    width: auto;
    max-width: 400px;
  }

  .wdbos-logo-container {
    margin-top: 2vh;
    padding: 1.5vh;
  }
}

@media (max-width: 768px) {
  .wdbos-rules-container {
    padding: 20px;
  }

  .wdbos-header-main {
    font-size: 2em;
  }

  .wdbos-logo-image {
    max-width: 400px;
  }
}

@media (max-width: 480px) {
  .wdbos-rules-container {
    padding: 15px;
  }

  .wdbos-header-main {
    font-size: 1.8em;
  }

  .wdbos-heading {
    font-size: 1.3em;
  }

  .wdbos-logo-image {
    max-width: 300px;
  }

  .wdbos-logo-container {
    margin-top: 20px;
    padding: 15px;
  }
}
#deposit .container .submit, #withdrawal .container .submit, .logout, .popUp .popUp-container .popUp-content .btn, .popUp .popUp-btns .btn, .black-gold-theme #mask .login-success-btn a, .forget-step .btn, .recommend-register a {
    background: #c8a177 !important;
    color: #fff !important;
    font-weight: bold;
}
</style>
